<template>
    <span>
        <div class="btn-group" v-if="permissions.admin">
            <button class="btn dropdown-toggle" :class="buttonClass" data-toggle="dropdown">
                <template v-if="isRejected">
                    Rejected
                </template>
                <template v-else-if="isApproved">
                    Scheduled
                </template>
                <template v-else-if="isReserve">
                    Reserve list
                </template>
                <template v-else>
                    Not yet scheduled
                </template>
                <span class="caret"></span>
            </button>

            <ul class="dropdown-menu">
                <li v-if="!isApproved">
                    <a :href="`/admin/subscriptions/${subscription.id}/add-to-schedule`">
                        <i class="fa fa-plus"></i> Add to schedule
                    </a>
                </li>
                <li v-if="!isReserve">
                    <a :href="`/admin/subscriptions/${subscription.id}/put-on-reserve-list`">
                        <i class="fa fa-pause"></i> Put on reserve list
                    </a>
                </li>
                <li v-if="!isRejected">
                    <a :href="`/admin/subscriptions/${subscription.id}/remove-from-schedule`">
                        <i class="fa fa-ban"></i> Reject
                    </a>
                </li>
                <li v-if="!isNull">
                    <a :href="`/admin/subscriptions/${subscription.id}/reset-schedule-status`">
                        <i class="fa fa-eraser"></i> Reset schedule status
                    </a>
                </li>
            </ul>
        </div>
        <div v-else>
            <span v-if="isRejected" class="label label-danger">Rejected</span>
            <span v-else-if="isApproved" class="label label-success">Scheduled</span>
            <span v-else-if="isReserve" class="label label-warning">Reserve list</span>
        </div>
    </span>
</template>

<script>
export default {
    props: ['subscription'],

    computed: {
        permissions() {
            return this.$store.state.permissions;
        },
        isNull() {
            return this.subscription.status === null;
        },
        isRejected() {
            return this.subscription.status === 0;
        },
        isApproved() {
            return this.subscription.status === 1;
        },
        isReserve() {
            return this.subscription.status === 2;
        },
        buttonClass() {
            if (this.isApproved) {
                return 'btn-success';
            } else if (this.isRejected) {
                return 'btn-danger';
            } else if (this.isReserve) {
                return 'btn-warning';
            }

            return 'btn-default'
        }
    }
}
</script>
